module.exports = __webpack_public_path__ + "files/1b6efcd98d74a8f4347134a4091f16a0.png";